import React from 'react';
import { Button, ButtonProps } from 'antd';
import classNames from 'classnames/dedupe';
import './lndButton.scss';

export type LndButtonProps = Omit<ButtonProps, 'variant'> & {
  variant?:
  | 'primary-outline'
  | 'secondary-outline'
  | 'default-outline'
  | 'success-outline'
  | 'danger-outline'
  | 'primary'
  | 'secondary'
  | 'black'
  | 'success'
  | 'danger'
  | 'light'
  | 'menu-outline'
  | 'text'
  | 'link'
  | 'option'
  | 'segment'
  | 'faded-text';
  active?: boolean;
};

const LndButton = React.forwardRef<HTMLButtonElement, LndButtonProps>(
  ({ variant, className, active, ...props }, ref) => {
    const classes = classNames('lnd-btn', className, {
      [variant || '']: variant,
      active: active,
    });

    return <Button ref={ref} className={classes} {...props} />;
  },
);

export default LndButton;
